import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('stockItem'),
  ...new Mutations('stockItems'),
  ...new Mutations('stockLimits'),
  ...new Mutations('favouriteStockItems'),
  ...new Mutations('divisionStockItems'),
};
